export const BIDDING_ERROR = {
  IS_LOGIN_USER_OWN_AUCTION: '자신의 경매에는 입찰할 수 없습니다.',
  IS_NOT_ACTIVE_AUCTION: '진행 중인 경매가 아닙니다.',
  IS_NOT_STARTED_AUCTION: '경매가 아직 시작되지 않아 입찰할 수 없습니다.',
  IS_ENDED_AUCTION: '경매가 종료되어 더 이상 입찰할 수 없습니다.',
  IS_DIFFERENT_MARKETPLACE: '타 마켓플레이스의 경매에 입찰할 수 없습니다.',
};

export const openBidding = {
  key: 'open_bidding',
  value: 'true',
};
